import * as effects from 'redux-saga/effects';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { profileActions } from '../../actions';

export function* deletePhoto() {
  try {
    yield effects.put(profileActions.startFetching());
    const response: Response = yield effects.apply(api, api.delete, [
      { endpoint: 'users/photo' },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }
    yield effects.put(profileActions.changePhoto({ photo: null }));
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(profileActions.stopFetching());
  }
}
